<template>
  <div class="ai-insights-section">
    <div v-if="resumeAnalysis">
      <div class="insight-card accomplishments-card">
        <h3 class="section-title">
          <span class="icon"><i class="mdi mdi-trophy-variant"></i></span>
          Key Career Accomplishments
        </h3>
        <ul class="accomplishments-list" v-if="resumeAnalysis.accomplishments && resumeAnalysis.accomplishments.length">
          <li
            v-for="(accomplishment, index) in resumeAnalysis.accomplishments"
            :key="`accomplishment-${index}`"
            class="accomplishment-item"
          >
            {{ accomplishment }}
          </li>
        </ul>
        <div v-else class="empty-state">
          <p>No accomplishments found.</p>
        </div>
      </div>
    </div>
    <div v-else class="empty-state">
      <p>No AI insights available for this resume.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CareerAccomplishments',
  props: {
    resumeAnalysis: {
      type: Object,
      required: true
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-insights-section {
  margin-bottom: 2rem;
}

.accomplishments-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;

  .icon {
    margin-right: 12px;
    color: $color-primary;
    font-size: 1.4rem;
  }
}

.accomplishments-list {
  padding-left: 0;
  list-style-type: none;

  .accomplishment-item {
    margin-bottom: 1rem;
    position: relative;
    line-height: 1.6;
    padding-left: 1.5rem;
    text-align: left;

    &:before {
      content: "•";
      color: $color-primary;
      font-weight: bold;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

.empty-state {
  text-align: center;
  color: $color-text-subtle;
  font-size: 1rem;
  padding: 2rem 0;
}
</style>